import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ligas } from '../../json/ligas';
import './ligas.css';

const Ligas = () => {  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container transparencia-container container-mh'>
        <div className='row'>
          <div className='col-12'>
            <h1 className='title'>Ligas de Interés</h1>
            <hr className='hr-gob'/>
          </div>
          {
                 ligas.map((item, index)=>(
                  <Link key={ index }  target="_blank" to={ item.url ? item.url : "" + item.nombre } className='col-md-4 col-sm-6 col-12 transparencia_item'>
                    <div className='ligas_container btn-cod-custom'>
                      { item.nombre }
                    </div>
                  </Link>
                ))
            }
            {/* <Link className='rubros_historicos' to="RubrosHistoricos">Información Ejercicios Anteriores Art. 69 (48 Fracciones)</Link> */}
        </div>
    </div>
  )
}

export default Ligas